export const testPrefix = 'settings-team';
